import { ref } from 'vue';
import { defineStore } from 'pinia';

export const useCalendarVersionStore = defineStore('calendarVersion', () => {
  const useNewCalendar = ref(false);

  return { useNewCalendar };
}, { persist: true });
